import { __rest, __assign } from 'tslib';
import React, { lazy, useState, useMemo, useCallback, useEffect, Suspense } from 'react';
import clsx from 'clsx';
import { debounce } from 'lodash-es';
import { cssTextarea } from './TextInputV2.css.js';

var Label = lazy(function () { return import('../label/Label.js').then(function (module) { return ({ default: module.Label }); }); });
var TextInputV2 = function (_a) {
    var id = _a.id, label = _a.label, _b = _a.displaySize, displaySize = _b === void 0 ? null : _b, className = _a.className, onChange = _a.onChange, required = _a.required, textarea = _a.textarea, onBlur = _a.onBlur, onFocus = _a.onFocus, delay = _a.delay, value = _a.value, _c = _a.removeWrapper, removeWrapper = _c === void 0 ? false : _c, _d = _a.removeLeadingZeros, removeLeadingZeros = _d === void 0 ? false : _d, inputProps = __rest(_a, ["id", "label", "displaySize", "className", "onChange", "required", "textarea", "onBlur", "onFocus", "delay", "value", "removeWrapper", "removeLeadingZeros"]);
    var _e = useState(''), stateValue = _e[0], setStateValue = _e[1];
    var debounceOnChange = useMemo(function () {
        return debounce(function (v, e) {
            onChange === null || onChange === void 0 ? void 0 : onChange(v, e);
        }, delay, { leading: false, trailing: true });
    }, [delay, onChange]);
    var onChangeInput = useCallback(function (e) {
        var value = e.target.value;
        var newValue = removeLeadingZeros && value !== '' && !isNaN(Number(value)) ? Number(value).toString() : value;
        setStateValue(newValue);
        delay ? debounceOnChange(newValue, e) : onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
    }, [debounceOnChange, delay, onChange, removeLeadingZeros]);
    var htmlInputProps = __assign({ id: id, className: clsx('c-input', displaySize ? "c-input--".concat(displaySize) : null), onChange: onChangeInput, onBlur: onBlur, onFocus: onFocus, value: stateValue, required: required }, inputProps);
    useEffect(function () {
        if (value !== undefined)
            setStateValue(value);
    }, [value]);
    useEffect(function () {
        return function () {
            debounceOnChange.cancel();
        };
    }, [debounceOnChange]);
    var content = (React.createElement(React.Fragment, null,
        !!label && (React.createElement(Suspense, { fallback: '' },
            React.createElement(Label, { htmlFor: id, required: required, "data-testid": "".concat(id ? "".concat(id, "-label") : '') }, label))),
        textarea ? (React.createElement("textarea", __assign({}, htmlInputProps, { className: "".concat(htmlInputProps.className, " ").concat(cssTextarea) }))) : (React.createElement("input", __assign({}, htmlInputProps)))));
    if (removeWrapper)
        return content;
    return (React.createElement("div", { className: className, "data-testid": "".concat(id ? "".concat(id, "-wrapper") : '') }, content));
};

export { TextInputV2 };
//# sourceMappingURL=TextInputV2.js.map
